var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"FooterBottom"}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/logo.png"),"alt":"SurRealLogo"}})]),_c('img',{attrs:{"src":require("@/assets/img/logo_corfo.png"),"alt":"Logo corfo"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("SurReal Travel SpA 2020. "),_c('span',[_vm._v("Todos los derechos reservados")])])
}]

export { render, staticRenderFns }